export const appImages = [
  {
    alt: 'App splash screen',
    image: '/images/network/app-images/splash.png',
  },
  {
    alt: 'App workout screen',
    image: '/images/network/app-images/workout.png',
  },
  {
    alt: 'App nutrition screen',
    image: '/images/network/app-images/nutrition.png',
  },
  {
    alt: 'App fertility screen',
    image: '/images/network/app-images/fertility.png',
  },
  {
    alt: 'App insights screen',
    image: '/images/network/app-images/insights.png',
  },
  {
    alt: 'App gaia screen',
    image: '/images/network/app-images/gaia.png',
  },
  {
    alt: 'App tracking screen',
    image: '/images/network/app-images/tracking.png',
  },
  {
    alt: 'App partner screen',
    image: '/images/network/app-images/partner.png',
  },
];
